import React, { useState, useEffect, useRef } from 'react';
import { Glyphicon } from 'react-bootstrap';

export default function MyAudioPlayer({ sourceFile, audioCtx, onStatusChange, onRemovePlayer }) {
    const [message, setMessage] = useState('');
    const [fileSelected, setFileSelected] = useState('');
    const localAudioRef = useRef(null);
    const mediaSourceNodeRef = useRef(null);

    useEffect(() => {
        if (sourceFile) loadAudioFile(sourceFile);
    }, [sourceFile]);

    function loadAudioFile(file) {
        setFileSelected(file.name);
        const reader = new FileReader();
        reader.onload = (e) => {
            localAudioRef.current.src = e.target.result;
            localAudioRef.current.pause();
            mediaSourceNodeRef.current = audioCtx.createMediaElementSource(localAudioRef.current);
            mediaSourceNodeRef.current.connect(audioCtx.destination);
        };
        reader.readAsDataURL(file);
    }

    function playerStarted() {
        audioCtx.resume().then(() => setMessage('Started'));
        onStatusChange('start', mediaSourceNodeRef.current, localAudioRef.current);
    }

    function playerStopped() {
        setMessage('Stopped');
        onStatusChange('stop', mediaSourceNodeRef.current, localAudioRef.current);
    }

    function playerCanStart() {
        setMessage('Loaded');
        onStatusChange('Loaded', mediaSourceNodeRef.current, localAudioRef.current);
    }

    return (
        <div>
            <span style={{ color: 'black' }}>
                {fileSelected}<br />
            </span>
            <audio controls className="cog"
                ref={localAudioRef}
                onPlay={playerStarted}
                onCanPlayThrough={playerCanStart}
                onPause={playerStopped} />
            <br />
            <span style={{ color: 'blue' }}>{message}</span>
            <Glyphicon glyph="trash" className="cog"
                style={{ position: 'absolute', top: 0, right: 0 }}
                name="trash"
                onClick={() => onRemovePlayer(fileSelected)} />
        </div>
    );
}
